import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
var TextComponent = forwardRef(function (_a, ref) {
    var tooltip = _a.tooltip, props = __rest(_a, ["tooltip"]);
    return (React.createElement(Tooltip, { label: tooltip || '' },
        React.createElement(Text, __assign({ ref: ref, noOfLines: 1, cursor: 'default' }, props))));
});
TextComponent.displayName = 'TextComponent';
export default TextComponent;
//# sourceMappingURL=TextComponent.js.map